import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Logo } from "components/Icons";
import { pluralize } from "helpers/coll";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { selectExpiringAuthenticationInfo, clearExpiringAuthenticationInfo } from "redux/slices/session";

const PasswordExpirationWarning = () => {
  const [canShowDialog, setCanShowDialog] = useState(true);
  const expiringAuthenticationInfo = useAppSelector(selectExpiringAuthenticationInfo);
  const dispatch = useAppDispatch();
  const passwordResetLink = `/reset-password?person=true&token=${expiringAuthenticationInfo?.passwordResetToken}`;

  const handleClose = () => {
    setCanShowDialog(false);
  };

  const handleExit = () => {
    dispatch(clearExpiringAuthenticationInfo());
    // Avoid # of days disappearing before dialog closes
    setCanShowDialog(true);
  };

  return (
    <Dialog
      open={canShowDialog && expiringAuthenticationInfo !== undefined}
      onClose={handleClose}
      TransitionProps={{
        onExited: handleExit,
      }}
      maxWidth="xs"
      fullWidth>
      <DialogTitle className="pt-6">
        <div className="flex items-center justify-center gap-3">
          <Logo size={32} />
          <p>Password Expiring Soon</p>
        </div>
      </DialogTitle>
      <DialogContent className="text-center">
        <p className="text-base font-medium mb-4 text-black">
          Your password will expire in <strong>{expiringAuthenticationInfo?.passwordExpirationDays} </strong>
          {pluralize(expiringAuthenticationInfo?.passwordExpirationDays ?? 0, "day")}.
        </p>
        <p className="text-xs font-normal text-gray-400">
          For security reasons, passwords must be updated every 90 days.
        </p>
        <p className="text-xs font-normal text-gray-400">To avoid any disruptions, please update your password now.</p>
      </DialogContent>
      <DialogActions className="flex items-center justify-center gap-8 pb-6">
        <Button href={passwordResetLink} variant="contained">
          Reset Password
        </Button>
        <Button onClick={handleClose} color="inherit">
          Remind Me Later
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordExpirationWarning;
